var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _vm.loading
        ? _c("BlockUI", { attrs: { message: "", html: _vm.html } })
        : _vm._e(),
      _vm._v(" "),
      _vm.accessToken != null
        ? _c("shared-primary-contact-form", { ref: "sharedPrimaryContactForm" })
        : _vm._e(),
      _vm._v(" "),
      _vm.accessToken != null
        ? _c("shared-member-contact-form", { ref: "sharedMemberContactForm" })
        : _vm._e(),
      _vm._v(" "),
      _vm.accessToken != null
        ? _c("shared-band-form", { ref: "sharedBandForm" })
        : _vm._e(),
      _vm._v(" "),
      _vm.accessToken != null
        ? _c("shared-company-form", { ref: "sharedCompanyForm" })
        : _vm._e(),
      _vm._v(" "),
      _c("router-view", {
        on: { showLoader: _vm.showLoader, hideLoader: _vm.hideLoader }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }